function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_10531",
  "data-name": "Group 10531",
  transform: "translate(598.381 -650.391)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_433",
  "data-name": "Line 433",
  y2: 35.168,
  transform: "translate(-571.391 652.512) rotate(45)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_434",
  "data-name": "Line 434",
  y1: 35.168,
  transform: "translate(-571.391 677.38) rotate(135)",
  fill: "none",
  stroke: "#a8a8a8",
  strokeLinecap: "round",
  strokeWidth: 3
}));
const SvgCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.11,
    height: 29.11,
    viewBox: "0 0 29.11 29.11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Cross.02503aeb.svg";
export { ForwardRef as ReactComponent };